import React, { useRef, useState } from 'react';
import Slider, { Settings } from 'react-slick';
import { CaretRight } from 'styled-icons/boxicons-regular/CaretRight';
import { CaretLeft } from 'styled-icons/boxicons-regular/CaretLeft';
import FavoriteButton from '~components/FavoriteButton';
import { ObjectType } from '~entities/Object';
import {
  Block,
  SliderFooter,
  SliderPhotoBtn,
  SliderPlanBtn,
  SliderArrow,
  SliderArrowWrapper,
  SliderImage,
  SliderFavoritesButtonWrapper,
  StyledSlickSlider,
  ID,
} from './styledComponents';

import 'slick-carousel/slick/slick.css';

type Props = {
  id_crm: ObjectType['id_crm'];
  srcs: string[];
  plansStartIndex?: number;
  imagesStartIndex: number;
  favorites?: { toggleFavorite: () => void; isInFavorites: boolean };
  onSlideClick: (index: number) => void;
  desktopSmallView?: boolean;
};

const ObjectPhotosSlider = ({
  desktopSmallView,
  srcs,
  plansStartIndex,
  imagesStartIndex,
  id_crm,
  favorites,
  onSlideClick,
}: Props) => {
  const sliderRef = useRef<Slider>(null);

  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);

  const sliderSettings: Settings = {
    infinite: true,
    speed: 500,
    lazyLoad: 'ondemand',
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: (
      <SliderArrowWrapper>
        <SliderArrow direction='right'>
          <CaretRight color='#7db828' size={27} />
        </SliderArrow>
      </SliderArrowWrapper>
    ),
    prevArrow: (
      <SliderArrowWrapper>
        <SliderArrow direction='left'>
          <CaretLeft color='#7db828' size={27} />
        </SliderArrow>
      </SliderArrowWrapper>
    ),
    afterChange: (slideIndex) => {
      setCurrentSlideIndex(slideIndex);
    },
  };

  const isImagesSlideActive =
    plansStartIndex !== undefined && currentSlideIndex >= imagesStartIndex;

  const scrollToPlans = () => {
    if (sliderRef.current !== null && plansStartIndex !== undefined) {
      sliderRef.current.slickGoTo(plansStartIndex);
    }
  };

  const scrollToImages = () => {
    if (sliderRef.current !== null) {
      sliderRef.current.slickGoTo(imagesStartIndex);
    }
  };

  return (
    <Block>
      <StyledSlickSlider
        desktopSmallView={desktopSmallView}
        ref={sliderRef}
        {...sliderSettings}
      >
        {srcs.map((src, i) => (
          <SliderImage key={src} src={src} onClick={() => onSlideClick(i)} />
        ))}
      </StyledSlickSlider>
      <SliderFooter>
        <div>
          {plansStartIndex !== undefined && (
            <>
              <SliderPhotoBtn
                title='Фотографии'
                isActive={isImagesSlideActive}
                onClick={scrollToImages}
              />
              <SliderPlanBtn
                title='Планировки'
                isActive={!isImagesSlideActive}
                onClick={scrollToPlans}
              />
            </>
          )}
        </div>
        <div>
          <ID>ID {id_crm} </ID>
          {favorites && (
            <SliderFavoritesButtonWrapper>
              <FavoriteButton
                isActiveGrey
                isActive={favorites.isInFavorites}
                size={16}
                onClick={favorites.toggleFavorite}
              />
            </SliderFavoritesButtonWrapper>
          )}
        </div>
      </SliderFooter>
    </Block>
  );
};

export default ObjectPhotosSlider;
